'use es6';

import styled from 'styled-components';
import SVGTextStyle from './SVGTextStyle';
export default styled(SVGTextStyle).withConfig({
  displayName: "SVGTextIconStyle",
  componentId: "pvk84p-0"
})(["font-family:'spacesword' !important;font-feature-settings:'liga';font-size:110%;font-variant:normal;font-weight:normal !important;letter-spacing:0;text-transform:none;"]);